import React from 'react';
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home.jsx';
import Network from './Components/Network/Network';
import FMS from './Components/FMS/FMS';
import BMS from './Components/BMS/BMS';
import PTS from './Components/PTS/PTS';
import AMR from './Components/AMR/AMR';    
import Food from './Components/Food/Food';
import EMS from './Components/EMS/EMS';
import VTS from './Components/VTS/VTS';
import Street from './Components/Street/Street';
import Contact from './Components/Contacts/Contact';
import Blog from './Components/Blog/Blog';
import Blog1 from './Components/Blog1/Blog1';
import Team from './Components/Team/Team';
import Overview from './Components/Overview/Overview';
import Explore from './Components/Explore/Explore';
import Product from './Components/Product/Product';
import Wired from './Components/Wired/Wired';
import Radio from './Components/Radio/Radio';
import Core from './Components/Core/Core';
import Protocol from './Components/Protocol/Protocol';
import ChatBox from './Components/Chatbox/Chatbox';
import PMS from './Components/PMS/PMS';
import Weather from './Components/Weather/Weather';
import Aqua from './Components/Aqua/Aqua';
import WQM from './Components/WQM/WQM';
import Parking from './Components/Parking/Parking';
import Visitors from './Components/Visitors/Visitors';
import FD from './Components/FD/FD';
import DTU from './Components/DTU/DTU';
import RGU from './Components/RGU/RGU';
import Industries from './Components/Industries/Industries';
import Management from './Components/Management/Management';
import ScrollToTop from './Components/Scroll.jsx';
import Careers from './Components/Careers/Careers';
import Lora from './Components/Lora/Lora.jsx';
import Fleet from './Components/FeulFleet/FuelFleet.jsx';
import Rfid from './Components/Rfid/Rfid.jsx';
import RReader from './Components/RfidReader/RfidReader.jsx';
import AMS from './Components/AMS/AMS.jsx';
import Metro from './Components/Metro/Metro.jsx';
import Burgular from './Components/Burgular/Burgular.jsx';
import RFBased from './Components/RFBased/RFBased.jsx';
import Coldstorage from './Components/Coldstorage/Coldstorage.jsx';
import Foodtransport from './Components/Foodtransport/Foodtransport.jsx';
import Gateway from './Components/Gateway/Gateway.jsx';
import Milestone from './Components/Milestone/Milestone.jsx';
import ML from './Components/ML/ML.jsx';
import AMRS from './Components/AMRS/AMRS.jsx';
import Software from './Components/Software/Software.jsx';
import FirmwareDesignPage from './Components/FirmwareDesignPage/FirmwareDesignPage.jsx';
import HardwareDesign from './Components/HardwareDesign/HardwareDesign.jsx';
import SoftwareDesign from './Components/SoftwareDesign/SoftwareDesign.jsx';
import MechDesign from './Components/MechDesign/MechDesign.jsx';
import Testing from './Components/Testing/Testing.jsx';
import EndtoEnd from './Components/EndtoEnd/EndtoEnd.jsx';
import Pcbmounting from './Components/Pcbmounting/Pcbmounting.jsx';
import Mobile1 from './Components/Mobile1/Mobile1.jsx';
import ProductEng from './Components/ProductEng/ProductEng.jsx';
import ProductandSol from './Components/ProductandaSol/ProductandSol.jsx';
import Manu from './Components/Manu/Manu.jsx';
import Techconsulting from './Components/Techconsulting/Techconsulting.jsx';
import Telecom from './Components/Telecom/Telecom.jsx';
import GIM from './Components/GIM/GIM.jsx';
import FuelSensor from './Components/FuelSensor/FuelSensor.jsx';
import ComingSoon from './Components/ComingSoon/ComingSoon.jsx';
import Electronics from './Components/Electronics/Electronics.jsx';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Solutions from './Components/Solution1/Solutions.jsx';
import Airconditioner from './Components/Airconditioner/Airconditioner.jsx';
import Health from './Components/Health/Health.jsx';

// Layout component to render common UI and Outlet for child routes
function Layout() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Outlet /> {/* Renders child route components */}
      <Footer />
      <ChatBox />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Layout route wrapping all child routes */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/network" element={<Network />} />
          <Route path="/Fuel-monitoring" element={<FMS />} />
          <Route path="/Battery-management" element={<BMS />} />
          <Route path="/Person-tracking-system" element={<PTS />} />
          <Route path="/Retrofit-AMR-solutions" element={<AMR />} />
          <Route path="/Food-chain-industries" element={<Food />} />
          <Route path="/Energy-monitoring-system" element={<EMS />} />
          <Route path="/Vehicle-Tracking-System" element={<VTS />} />
          <Route path="/Street-light-control" element={<Street />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/Blog1" element={<Blog1 />} />
          <Route path="/Careers" element={<Careers />} />
          <Route path="/Team" element={<Team />} />
          <Route path="/Overview" element={<Overview />} />
          <Route path="/Explore" element={<Explore />} />
          <Route path="/Product" element={<Product />} />
          <Route path="/Wired" element={<Wired />} />
          <Route path="/Radio" element={<Radio />} />
          <Route path="/Core" element={<Core />} />
          <Route path="/Protocol" element={<Protocol />} />
          <Route path="/Prepaid-meter-solution" element={<PMS />} />
          <Route path="/Weather-Monitoring" element={<Weather />} />
          <Route path="/AQUA" element={<Aqua />} />
          <Route path="/Water-quality-management-solution" element={<WQM />} />
          <Route path="/Parking-Management" element={<Parking />} />
          <Route path="/Visitor-Management" element={<Visitors />} />
          <Route path="/Fire-detection" element={<FD />} />
          <Route path="/Data-transfer-unit" element={<DTU />} />
          <Route path="/Remote-gateway-unit" element={<RGU />} />
          <Route path="/PMS-for-food-grade-industries" element={<Industries />} />
          <Route path="/Management-of-lights-air-conditioning-fire-detection-surveillance" element={<Management />} />
          <Route path="/lora-based-water-meter" element={<Lora />} />
          <Route path="/fuel-and-fleet-management" element={<Fleet />} />
          <Route path="/rfid-tag" element={<Rfid />} />
          <Route path="/RFID-Reader" element={<RReader />} />
          <Route path="/Asset-Monitoring-System" element={<AMS />} />
          <Route path="/Metro-Water-Quality" element={<Metro />} />
          <Route path="/Burgular-Alarm-System" element={<Burgular />} />
          <Route path="/Temperature-Monitoring-For-Cold-Storage" element={<Coldstorage />} />
          <Route path="/Temperature-Monitoring-For-Food-and-Transport" element={<Foodtransport />} />
          <Route path="/remote-gateways" element={<Gateway />} />
          <Route path="/Milestone" element={<Milestone />} />
          <Route path="/ML" element={<ML />} />
          <Route path="/AMRS" element={<AMRS />} />
          <Route path="/Software" element={<Software />} />
          <Route path="/FirmwareDesignPage" element={<FirmwareDesignPage />} />
          <Route path="/HardwareDesign" element={<HardwareDesign />} />
          <Route path="/SoftwareDesign" element={<SoftwareDesign />} />
          <Route path="/MechDesign" element={<MechDesign />} />   
          <Route path="/Testing" element={<Testing />} />
          <Route path="/EndtoEnd" element={<EndtoEnd />} />
          <Route path="/Pcbmounting" element={<Pcbmounting />} />
          <Route path="/Mobile1" element={<Mobile1 />} />
          <Route path="/ProductEng" element={<ProductEng />} />
          <Route path="/ProductandSol" element={<ProductandSol />} />
          <Route path="/Manu" element={<Manu />} />
          <Route path="/Techconsulting" element={<Techconsulting />} />
          <Route path="/Telecom" element={<Telecom />} />
          <Route path="/GIM" element={<GIM />} />
          <Route path="/FuelSensor" element={<FuelSensor />} />
          <Route path="/ComingSoon" element={<ComingSoon />} />
          <Route path="/Electronics" element={<Electronics />} />
          <Route path="/Solution1" element={<Solutions />} />
          <Route path="/Airconditioner" element={<Airconditioner />} />
          <Route path="/Health" element={<Health />} />
        </Route>
        {/* Catch-all route for 404 */}
        <Route path="*" element={<div>404 - Page Not Found</div>} />
      </Routes>
    </Router>
  );
}

export default App; 